/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Gd } from './Gd';

class Goods extends Gd {
    constructor() {
        super();
        this.baseUrl += '/goods';
    }

    data({
        goodsName,
        goodsSn,
        goodsCatId,
        supplierId,
        goodsStatusType,
        servantGoodsCatId,
        schoolOrgId,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/data', {
            goodsName,
            goodsSn,
            goodsCatId,
            supplierId,
            goodsStatusType,
            servantGoodsCatId,
            schoolOrgId,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/getDetail', { id });
    }

    getGoodsDetailVo({ id }) {
        return super.get('/getGoodsDetailVo', { id });
    }

    save(data) {
        return super.postJson('/save', data);
    }

    saveAndPublish(data) {
        return super.postJson('/saveAndPublish', data);
    }

    onSaleGoods({ goodsId, orderDetailListJson }) {
        return super.post('/onSaleGoods', { goodsId, orderDetailListJson });
    }

    offSaleGoods({ goodsId }) {
        return super.post('/offSaleGoods', { goodsId });
    }

    /**
     * 获取商品(当选择/装修时用)
     * @param ids 有值不分页
     * @param orderByKey
     * @param orderByType
     *
     * @param goodsName
     * @param goodsSn
     * @param goodsStatus
     * @param isservantStoreGoods
     * @param currentPage
     * @param pageSize
     * @returns {AxiosPromise<any>}
     */
    selectByPage(
        {
            ids,
            orderByKey,
            orderByType,
            goodsName,
            goodsSn,
            goodsStatus,
            servantGoodsCatIdNE,
            schoolOrgId,
            currentPage,
            pageSize,
        } = {},
        config,
    ) {
        return super.get(
            '/selectByPage',
            {
                ids,
                orderByKey,
                orderByType,
                goodsName,
                goodsSn,
                goodsStatus,
                servantGoodsCatIdNE,
                schoolOrgId,
                currentPage,
                pageSize,
            },
            {
                isRepeat: true,
                ...config,
            },
        );
    }

    changeOrderNum({ id, orderNum }) {
        return super.post('/changeOrderNum', { id, orderNum });
    }

    changeBaseSales({ id, baseSales }) {
        return super.post('/changeBaseSales', { id, baseSales });
    }

    batchSetBaseSales(data) {
        return super.post('/batchSetBaseSales', data);
    }

    editGoods({ id, goodsShareCopy, goodsMultiStyleJson }) {
        return super.post('/editGoods', { id, goodsShareCopy, goodsMultiStyleJson });
    }

    saveGoodsServantGoodsCat({ goodsIds, servantGoodsCatId }) {
        return super.post('/saveGoodsServantGoodsCat', { goodsIds, servantGoodsCatId });
    }

    delGoodsServantGoodsCat({ goodsIds, servantGoodsCatId }) {
        return super.post('/delGoodsServantGoodsCat', { goodsIds, servantGoodsCatId });
    }

    findSkuMapList({
        goodsName,
        goodsSn,
        skuSn,
        specDesc,
        certCatId,
        certExamType,
        schoolOrgId,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/findSkuMapList', {
            goodsName,
            goodsSn,
            skuSn,
            specDesc,
            certCatId,
            certExamType,
            schoolOrgId,
            currentPage,
            pageSize,
        });
    }
}

export default new Goods();
export { Goods };
